// extracted by mini-css-extract-plugin
module.exports = {"EventList":"ComponentBodyEventList_EventList__QPnew"};